import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';

import { errorHandler } from 'utils';

import { useJobNotificationContext } from 'containers/common/JobNotificationProvider';

import { Mui } from 'components';
import { generateExport } from 'components/common/DataTable/utils';
import { Drawer } from 'components/layouts';

function ExportAnalyticsReport({
  exportAction,
  exportData,
  exportFileName,
  query,
  reportLabel,
  detailedReportLabel,
}) {
  const { trackJob } = useJobNotificationContext();
  const { sellerSlug } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [exporting, setExporting] = useState(false);

  const handleSuccess = res => {
    const { job: jobUid } = res?.data;
    trackJob(jobUid);
    enqueueSnackbar('A sua solicitação foi enviada com sucesso, em breve você será notificado', {
      variant: 'info',
    });
    setOpen(false);
  };

  const handleFailure = error =>
    enqueueSnackbar(errorHandler(error.response?.data), {
      variant: 'error',
    });

  const handleExportDetailed = () => {
    setExporting(true);
    return exportAction({ sellerSlug, query })
      .then(handleSuccess)
      .catch(handleFailure)
      .then(() => setExporting(false));
  };

  const hasSummaryExport = exportData && exportData.length > 1;
  const hasDetailedExport = Boolean(exportAction);

  if (!hasSummaryExport && !hasDetailedExport) return null;

  return (
    <>
      <Mui.Button
        startIcon={<Mui.Icon>get_app</Mui.Icon>}
        variant="outlined"
        color="primary"
        onClick={() => setOpen(true)}>
        Relatórios
      </Mui.Button>
      <Drawer
        onClose={() => setOpen(false)}
        title="Relatórios"
        description="Os relatórios solicitados serão processados dentro de alguns minutos e enviados ao seu e-mail."
        open={open}>
        <Mui.Container>
          <Mui.Card variant="outlined">
            <Mui.List style={{ padding: 0 }}>
              {hasSummaryExport && (
                <Mui.ListItem
                  divider={hasDetailedExport}
                  button
                  onClick={() =>
                    generateExport(exportFileName, exportData, {
                      type: 'array',
                      skipHeader: 1,
                    })
                  }
                  disabled={exporting}>
                  <Mui.ListItemAvatar>
                    <Mui.Avatar>
                      <Mui.Icon>receipt</Mui.Icon>
                    </Mui.Avatar>
                  </Mui.ListItemAvatar>
                  <Mui.ListItemText primary={reportLabel || 'Relatório resumido'} />
                </Mui.ListItem>
              )}
              {hasDetailedExport && (
                <Mui.ListItem button onClick={handleExportDetailed} disabled={exporting}>
                  <Mui.ListItemAvatar>
                    <Mui.Avatar>
                      <Mui.Icon>list_alt</Mui.Icon>
                    </Mui.Avatar>
                  </Mui.ListItemAvatar>
                  <Mui.ListItemText primary={detailedReportLabel || 'Relatório detalhado'} />
                </Mui.ListItem>
              )}
            </Mui.List>
          </Mui.Card>
        </Mui.Container>
      </Drawer>
    </>
  );
}

ExportAnalyticsReport.propTypes = {
  exportAction: PropTypes.func,
  exportData: PropTypes.array,
  exportFileName: PropTypes.string,
  query: PropTypes.object,
  reportLabel: PropTypes.string,
  detailedReportLabel: PropTypes.string,
};

export default ExportAnalyticsReport;
